import { render, staticRenderFns } from "./CreateDomainDialog.vue?vue&type=template&id=d01d9be6"
import script from "./CreateDomainDialog.vue?vue&type=script&lang=js"
export * from "./CreateDomainDialog.vue?vue&type=script&lang=js"
import style0 from "./CreateDomainDialog.vue?vue&type=style&index=0&id=d01d9be6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports